import { useState } from 'react'

import { IChatProps } from '@/types/gigiChat/Chat'

import FeedbackDrawer from '../feedback/components/drawer'
import Messages from './components/Messages'
import Search from './components/Search'

const Chat = ({ messages, onNewQuestion, onStopStreaming, settings, onCreateNewChat, chatId }: IChatProps) => {
    const [isInputFullExpanded, setIsInputFullExpanded] = useState<boolean>(false)

    const onFullInputExpand = () => {
        setIsInputFullExpanded(!isInputFullExpanded)
    }

    return (
        <>
            <Messages
                messages={messages}
                shouldDisplay={!isInputFullExpanded}
                settings={settings}
                chatId={chatId}
                onNewQuestion={onNewQuestion}
            />
            <Search
                onCreateNewChat={onCreateNewChat}
                handleSendMessage={onNewQuestion}
                onFullInputExpand={onFullInputExpand}
                isInputFullExpanded={isInputFullExpanded}
                onStopStreaming={onStopStreaming}
            />
            <FeedbackDrawer />
        </>
    )
}

export default Chat
